$shm_hitalama_taskmanager_priority $mol_select
	dictionary <= priority_dictionary *
		low \Low
		normal \Normal
		high \High
	Filter null
	Trigger_icon null
	trigger_content /
		<= Dot $mol_view
			style *
				^
				backgroundColor <= value_color \
	option_content* /
		<= Option_dot* $mol_view
			style *
				^
				backgroundColor <= priority_color* \
		<= Option_label* $mol_dimmer
			haystack <= option_label*
			needle \
